import {Component} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {TranslocoDirective} from '@jsverse/transloco';
import {environment} from '@environments/environment';
import {RouterLink} from '@angular/router';
import {RouteGenerator} from '@core/route-generator';
import {UI_ROUTES} from '@core/ui.routes';

@Component({
  selector: 'app-public-terms-privacy',
  imports: [
    ReactiveFormsModule,
    TranslocoDirective,
    RouterLink
  ],
  templateUrl: './terms-privacy.component.html',
  styleUrl: './terms-privacy.component.scss'
})
export class TermsPrivacyComponent {
  public readonly domain = environment.domain;
  public readonly appName = environment.appName;
  public readonly contactEmail = environment.contactEmail;

  public readonly routes = {
    terms: RouteGenerator.abs(UI_ROUTES.public.terms.home)
  };
}
